import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    data: []
};
const memorySlice = createSlice({
    name: "memory",
    initialState,
    reducers: {
        setMemoryMetrics (state, action) {
            const { totalMemory, usedMemory } = action.payload;
            state.totalMemory = totalMemory;
            state.usedMemory = usedMemory;
            if (totalMemory !== undefined && usedMemory !== undefined) {
                state.latestMemoryUtilization = usedMemory / totalMemory * 100;
            }
        },
        setHistoricalData (state, action) {
            const { key, data } = action.payload;
            state[key] = data;
        },
        addMemoryUtilizationDataPoint (state) {
            const now = Date.now();
            const oldestPoint = now - 60 * 60 * 1000;
            const filtered = state.data.filter((d)=>d.x >= oldestPoint);
            if (state.latestMemoryUtilization != null) {
                const newPoint = {
                    x: now,
                    y: state.latestMemoryUtilization
                };
                state.data = [
                    ...filtered,
                    newPoint
                ];
            } else {
                state.data = filtered;
            }
        }
    }
});
export const { setMemoryMetrics, setHistoricalData, addMemoryUtilizationDataPoint } = memorySlice.actions;
export default memorySlice.reducer;
